import primaryComponents from "../../../primaryComponents";
import {
  ArrowRight,
  ExclamationCirlce,
  PlusIcon,
} from "../../../../assets/svgIcons";
import styles from "./styles.module.scss";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { useSmsCampaignContentForm } from "./useSmsCampaignContentForm";
import { RoutedModal } from "../../../common";
import { SmsSenderIdForm } from "../SmsSenderIdForm";
import { useValidation } from "./useValidation";
import secondaryComponents from "../..";
import { TagsView } from "./TagsView";

export const SmsCampaignContentForm = ({ smsCampaign = {} }) => {
  const {
    isSubmiting,
    formData,
    isSenderId,
    isLoading,
    senderList,
    textareaRef,
    setIsSenderId,
    setFormData,
    handleSubmitContent,
    handleInsert,
  } = useSmsCampaignContentForm({
    smsCampaign,
  });

  const {
    control,
    formState: { errors },
    handleSubmit,
    trigger,
  } = useValidation({ ...formData });

  const segments = parseInt(formData?.message_body?.length / 160) + 1;

  return (
    <>
      <div className={styles.smsCampaignContentForm}>
        <form
          className={styles.smsCampaignContentForm__left}
          onSubmit={handleSubmit(handleSubmitContent)}
        >
          <div>
            <h5>Sender Identity & Message</h5>
            {/* <p>
              Choose the target group or individuals that will receieve this
              campaign
            </p> */}
          </div>

          <secondaryComponents.LoaderHelper
            classNames={"mt-5"}
            isLoading={isLoading}
          >
            <div
              className={` ${globalStyles["cardWithBackground"]} ${styles.body}`}
            >
              <div
                className={`${globalStyles["cardWithBackground"]} white`}
                style={{ gap: "30px" }}
              >
                <div>
                  <h6>Select Sender ID</h6>
                  <div className="d-flex" style={{ gap: "5px" }}>
                    <div className="w-100">
                      <primaryComponents.SelectFieldV2
                        control={control}
                        name="sender_id"
                        isRequired
                        value={
                          senderList?.find(
                            (sender) =>
                              `${sender?.id}` === `${formData?.sender_id}`,
                          )?.sender_id || "Select..."
                        }
                        nameKey="sender_id"
                        idKey="id"
                        options={senderList}
                        onChange={(value) => {
                          setFormData((prev) => ({
                            ...prev,
                            sender_id: value,
                          }));
                        }}
                        errorMessage={errors?.message_body}
                      />
                    </div>
                    <primaryComponents.Button
                      classNames={"btn btn--outline"}
                      type="button"
                      onClick={() => setIsSenderId(true)}
                    >
                      <PlusIcon className="mr-1" />
                      New ID
                    </primaryComponents.Button>
                  </div>
                </div>

                <div>
                  <h6>Message Content</h6>
                  <div
                    className={`${globalStyles["cardWithBorder"]} px-0 pt-0`}
                  >
                    <div
                      className={`${globalStyles["cardWithBackground"]} flex-row align-items-center`}
                      style={{
                        gap: "15px",
                        overflowX: "auto",
                      }}
                    >
                      <p className="small-text-size mr-auto">INSERT:</p>
                      <TagsView
                        tags={
                          smsCampaign?.tags || smsCampaign?.audience?.tags || []
                        }
                        handleSetTags={(tag) => {
                          handleInsert(tag);
                        }}
                      />
                    </div>

                    <primaryComponents.TextAreaV2
                      ref={textareaRef}
                      control={control}
                      name="message_body"
                      placeholder={"Type your message here"}
                      style={{
                        borderColor: "transparent",
                        borderBottomColor: "#ddd",
                        height: "170px",
                      }}
                      value={formData?.message_body}
                      onChange={({ target: { value } }) => {
                        setFormData((prev) => ({
                          ...prev,
                          message_body: value,
                        }));
                      }}
                      errorMessage={errors?.message_body}
                      onKeyUp={() =>
                        errors?.message_body && trigger("message_body")
                      }
                      floatError={false}
                    />
                    <p className="ml-auto mr-2">
                      {formData?.message_body?.length} / 160 SMS ({segments}{" "}
                      {segments > 1 ? "pages" : "page"})
                    </p>
                  </div>
                </div>

                <p className="d-flex align-items-center">
                  <ExclamationCirlce className="mr-2" width="22" height="22" />
                  <span>
                    Variables like {"{{first_name}}"} will be replaced
                    dynamically for each recipient
                  </span>
                </p>

                <primaryComponents.Button
                  classNames={"btn btn--primary ml-auto"}
                  isLoading={isSubmiting}
                  isDisabled={isSubmiting}
                  loadingText={"Processing..."}
                  type="submit"
                >
                  Next: Schedule Delivery <ArrowRight className="ml-1" />
                </primaryComponents.Button>
              </div>
            </div>
          </secondaryComponents.LoaderHelper>
        </form>

        {/* <div className={`${styles.smsCampaignContentForm__right}`}> */}
        {/* <ContentSummary /> */}
        {/* </div> */}
      </div>

      <RoutedModal
        isActive={isSenderId}
        width={550}
        headerTitle="Create Sender ID"
        closeModal={() => setIsSenderId(false)}
        style={{ height: "auto" }}
      >
        <SmsSenderIdForm closeModal={() => setIsSenderId(false)} />
      </RoutedModal>
    </>
  );
};
